import { useMutation } from "react-query";
import { API } from "../../../utils/AxiosInstance";

interface SessionUpdateResponse {
    success: boolean;
    token: string;
    user_id: string;
    user_name: string;
    email: string;
    cohort: string[];
    ma_cohorts: string[];
}

export const useSessionUpdateMutation = () =>
    useMutation<SessionUpdateResponse, unknown, string>((token: string) =>
        API.put<SessionUpdateResponse>(`/sessions/${token}/mercy`).then(
            (resp) => resp.data
        )
    );
